import { defineLibraryConfig } from "library/defaultConfig"

export default defineLibraryConfig({})
